import { createReducer } from '@reduxjs/toolkit';
import type { Draft } from '@reduxjs/toolkit';
import type { Action } from 'redux';

import { LOGIN_SUCCESS, UNAUTHORIZED_RESPONSE, SAVE_LAST_LOCATION } from './actionTypes';
import type { User } from './types';

export interface State {
  isAuthenticated: boolean;
  currentUserId: string | null;
  lastLocation: string | undefined;
}

export const initialState: State = {
  isAuthenticated: false,
  currentUserId: null,
  lastLocation: undefined,
};

type LoginSuccessAction = Action<typeof LOGIN_SUCCESS> & { user: User };
type SaveLastLocationAction = Action<typeof SAVE_LAST_LOCATION> & { pathname: string };

const loginSuccess = (state: Draft<State>, action: LoginSuccessAction) => {
  state.isAuthenticated = true;
  state.currentUserId = action.user.id;
  state.lastLocation = undefined;
};

const unauthorizedResponse = (state: Draft<State>) => {
  state.isAuthenticated = false;
  state.currentUserId = null;
};

const saveLastLocation = (state: Draft<State>, action: SaveLastLocationAction) => {
  state.lastLocation = action.pathname;
};

export const reducer = createReducer(initialState, (builder) => {
  builder.addCase(LOGIN_SUCCESS, loginSuccess);
  builder.addCase(UNAUTHORIZED_RESPONSE, unauthorizedResponse);
  builder.addCase(SAVE_LAST_LOCATION, saveLastLocation);
});
